export const CATEGORY_SLUGS = {
  ICONS_AND_INFLUENCES: "icons-and-influences",
  LABOR_AND_LIVELIHOOD: "labor-and-livelihood",
  SERVICE_AND_SACRIFICE: "service-and-sacrifice",
  INNOVATORS_AND_VISIONARIES: "innovators-and-visionaries",
  CULTURE_AND_HERITAGE: "culture-and-heritage",
} as const;

export const CATEGORY_MAP: Record<string, string> = {
  [CATEGORY_SLUGS.ICONS_AND_INFLUENCES]: "Icons & Influences",
  [CATEGORY_SLUGS.LABOR_AND_LIVELIHOOD]: "Labor & Livelihood",
  [CATEGORY_SLUGS.SERVICE_AND_SACRIFICE]: "Service & Sacrifice",
  [CATEGORY_SLUGS.INNOVATORS_AND_VISIONARIES]: "Innovators & Visionaries",
  [CATEGORY_SLUGS.CULTURE_AND_HERITAGE]: "Culture & Heritage",
};
